export default "__VITE_ASSET__DZ_art0M__"